<script>
export default {
  name: 'PrintButton',
  data() {
    return {
      text: 'Skriv ut',
    };
  },
  mounted() {
    const lang = document.documentElement.lang;
    if (lang === 'en') {
      this.text = 'Print';
    }
  },
  methods: {
    printPage() {
      window.print();
    },
  },
};
</script>

<template>
  <button class="small-font print-button" @click="printPage">
    <i aria-hidden="true" class="material-icons">print</i>
    <span>{{ text }}</span>
  </button>
</template>
